import { render, staticRenderFns } from "./BrokerGeneral.vue?vue&type=template&id=2b5176aa"
import script from "./BrokerGeneral.vue?vue&type=script&lang=js"
export * from "./BrokerGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports